<template>
  <q-card class="auth-card relative-position">
    <q-card-main>
      <h1 class="text-center auth-card__heading">{{ $t('tfa_heading') }}</h1>
      <p class="text-center auth-card__description">{{ $t('tfa_description') }}</p>

      <form id="login-form" @submit.prevent="handleLogin">
        <q-field :error="errors.has('otpCode')" :error-label="errors.first('otpCode')">
          <q-input
            name="otpCode"
            ref="otpCode"
            v-model="verificationCode"
            v-validate.disable="'required'"
            :float-label="$t('otp_code')"
            required
            autofocus/>
        </q-field>

        <div class="auth-card__footer row justify-end">
          <div class="col-md-auto col-xs-12 self-center auth-card__primary-action">
            <q-btn type="submit" color="primary">{{ $t('login') }}</q-btn>
          </div>
        </div>
      </form>
    </q-card-main>

    <q-inner-loading :visible="loading"/>
  </q-card>
</template>

<script>
  import { createErrorFromResponse, getErrorCodeFromResponse } from 'src/utils/error'
  import { mapActions, mapGetters } from 'vuex'
  import { auth } from 'src/config'

  export default {
    $_veeValidate: {
      validator: 'new'
    },

    data () {
      return {
        verificationCode: null,
        loading: false
      }
    },

    computed: mapGetters(['credentials']),

    methods: {
      ...mapActions(['login', 'deleteCredentials']),

      handleLogin () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) {
              return
            }

            this.loading = true

            return this.login({
              email: this.credentials.email,
              password: this.credentials.password,
              otp: this.verificationCode
            })
              .then(() => {
                this.$router.replace('/')
              })
              .catch(error => {
                this.loading = false

                this.showError(error)
              })
          })
      },

      showError (error) {
        if (error.response) {
          createErrorFromResponse(error)

          if (getErrorCodeFromResponse(error) === '2FA_INVALID') {
            this.resetOtp()
          }
        } else if (error.message) {
          // Todo: this case should probably also translated
          this.$q.notify({ message: error.message, type: 'negative' })
        }
      },

      resetOtp () {
        this.verificationCode = null
        this.$refs.otpCode.focus()
      }
    },

    created () {
      if (!this.credentials) this.$router.replace({ name: 'login' })
    },

    watch: {
      verificationCode (code) {
        if (!code || code.length !== auth.otp_length) return

        this.handleLogin()
      }
    },

    beforeRouteLeave (to, from, next) {
      this.deleteCredentials()

      next()
    }
  }
</script>
